import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Card } from 'src/domains/players/webview/components/Account/common/card/Card';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    CardsBalancesRowsContainer,
    CardBalancesRowTitleContainer,
    CardBalancesRowTitle,
    ChevronRight,
    CardBalancesRowText,
    RowLink,
    GiftIconStyled,
    RewardIconStyled,
    CardBalancesRowValue,
} from './CardRows.style';
import { BonusBalanceModel } from 'src/domains/players/state/BonusBalanceModel';
import { useCommon } from 'src/domains/common/Common';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const CardRows = observer('CardRows', () => {
    const common = useCommon();
    const bonusBalanceModel = BonusBalanceModel.get(common);
    const config = ConfigComponents.get(common);

    React.useEffect(() => {
        bonusBalanceModel.bonusBalances.refresh();
    }, []);

    const freeBetsAmount = config.precision.newFromOld(bonusBalanceModel.processedBonusBalances.freeBets);

    return (
        <CardsBalancesRowsContainer>
            <RowLink
                to={{
                    account: 'credits',
                    type: 'free-bets',
                }}
                dataTest='free-bets-history'
            >
                <Card>
                    <CardBalancesRowTitleContainer>
                        <CardBalancesRowTitle>
                            <I18n
                                langKey='account.summary.free-bets'
                                defaultText='Free Bets'
                            />
                        </CardBalancesRowTitle>
                        <ChevronRight position='right' />
                    </CardBalancesRowTitleContainer>
                    <CardBalancesRowText>
                        <GiftIconStyled />
                        <CardBalancesRowValue>{BasicDataModel.get(common).money(freeBetsAmount)}</CardBalancesRowValue>
                    </CardBalancesRowText>
                </Card>
            </RowLink>
            <RowLink
                to={{
                    account: 'credits',
                    type: 'free-spins',
                }}
                dataTest='free-spins-history'
            >
                <Card>
                    <CardBalancesRowTitleContainer>
                        <CardBalancesRowTitle>
                            <I18n
                                langKey='account.summary.free-spins'
                                defaultText='Free Spins'
                            />
                        </CardBalancesRowTitle>
                        <ChevronRight position='right' />
                    </CardBalancesRowTitleContainer>
                    <CardBalancesRowText>
                        <RewardIconStyled />
                        <CardBalancesRowValue>
                            {bonusBalanceModel.processedBonusBalances.freeSpins}
                        </CardBalancesRowValue>
                    </CardBalancesRowText>
                </Card>
            </RowLink>
        </CardsBalancesRowsContainer>
    );
});
